import snakeCase from 'lodash/snakeCase';

import { CATEGORY_ID_MAP } from 'context/updates/constants';

import { POSTS_PER_PAGE } from './UpdatesList.constants';

export const setFeaturedStatus = posts => {
  return posts.map((node, index) => ({
    ...node,
    // Set first and last posts as featured.
    featured: [0, 5].includes(index % POSTS_PER_PAGE),
  }));
};

export const filterPosts = (posts, filter) => {
  const category = snakeCase(filter).toUpperCase();
  const categoryId = CATEGORY_ID_MAP[category];
  if (category === 'ALL') {
    return setFeaturedStatus(posts);
  }
  const result = posts.filter(post => post.categories.includes(categoryId));
  return setFeaturedStatus(result);
};
